<template>
  <div class="container">
    <b-row>
      <div class="col-sm-6">
        <div class="ld-card-header">
          <img src="@/assets/images/chr-logo.png" alt="christian tour logo" class="logo-img">
        </div>
      </div>
      <div class="col-sm-6">
        <div class="float-right"  v-b-tooltip.hover :title="$gettext('Close')">
          <b-iconstack font-scale=".8" @click="$emit('closeModal')">
            <b-icon stacked icon="square"></b-icon>
            <b-icon stacked icon="x"></b-icon>
          </b-iconstack>
        </div>
      </div>
      <b-col sm="12"><hr></b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'modalHeader'
}
</script>
